export default {
  visitList: {},
  visitTypeList: [],
  signInList: {
    list: [],
  },
  signInDetail: {
    record: [],
  },
  salesmanTableData: {},
  busiLineTableData: {},
  customTableData: {},
  depaBusiLineTableData: {},
  threeBusiLineTableData: {},
  departmentTableData: {},
  cusInsuranceTableData: {},
  cusBankTableData: {},
  cusHealManagementTableData: {},
  cusInternetTableData: {},
  cusOprationTableData: {},
  dep3OfBusPerformanceTableData: {},
  customerRevenueTableData: {},
  timingRecordList: {},
  timingRecordTeams: [],
  timingRecordDetail: [],
  proOnlineTopData: {},
  proOfflineTopData: {},
  telCounselingTableData: [],
  offlineServiceTableData: {},
  customSelectData: {},
  doctelConnectionList: {},
  statisticsTeamList: [],
};
